(function () {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    const gallerythumbnails = document.querySelectorAll("[data-gallerythumbnail]");

    for (const gallerythumbnail of gallerythumbnails) {
      updateGallerythumbnail(gallerythumbnail);
    }
    initializeArrowNavigation();
  }

  function scrollThumbLeftAlign(container, element) {
    if (!container || !element) return;
    let x = 0, el = element;
    while (el && el !== container) {
      x += el.offsetLeft;
      el = el.offsetParent;
    }
    const targetLeft = x - container.offsetLeft;
    container.scrollTo({ left: targetLeft, behavior: "smooth" });
  }

  function updateArrowStates(index, prevBtn, nextBtn, totalSlides) {
    if (!prevBtn || !nextBtn) return;
  
    if (index <= 0) {
      prevBtn.classList.add('is-disabled');
      prevBtn.setAttribute('disabled', 'disabled');
    } else {
      prevBtn.classList.remove('is-disabled');
      prevBtn.removeAttribute('disabled');
    }
  
    if (index >= totalSlides - 1) {
      nextBtn.classList.add('is-disabled');
      nextBtn.setAttribute('disabled', 'disabled');
    } else {
      nextBtn.classList.remove('is-disabled');
      nextBtn.removeAttribute('disabled');
    }
  }
  

  // FIXED: Create consistent selector function used by all functions
  function getActiveMediaItems(mediaGallery) {
    const isCustomTemplate = document.querySelector('.eva-custom-product-container') !== null;

    let mediaItems = isCustomTemplate
      ? mediaGallery.querySelectorAll(".variant-slide.variant-slide--desktop.product__media-item.is-active")
      : mediaGallery.querySelectorAll(".variant-slide.product__media-item.is-active");
    
    // Fallback if no items found
    if (mediaItems.length === 0) {
      mediaItems = mediaGallery.querySelectorAll(".variant-slide.product__media-item.is-active");
    }

    return mediaItems;
  }

  function updateGallerythumbnail(gallerythumbnail) {
    while (gallerythumbnail.hasChildNodes()) {
      gallerythumbnail.removeChild(gallerythumbnail.lastChild);
    }

    const mediaWrapper = gallerythumbnail.parentElement;
    const mediaGallery = mediaWrapper.querySelector("media-gallery");
    
    // FIXED: Use consistent selector function
    const mediaItems = getActiveMediaItems(mediaGallery);

    const currentImagesLength = mediaItems.length;
    console.log(`Current variant has ${currentImagesLength} images`);

    for (let i = 0; i < mediaItems.length; i++) {
      const item = mediaItems[i];
      const itemImage = item.querySelector("img");
      
      if (!itemImage) continue; // Skip if no image found

      const button = document.createElement("button");
      button.classList.add("gallerythumbnail--button");
      button.type = "button";
      button.setAttribute("data-index", i);

      button.addEventListener(
        "click",
        scrollItemIntoView.bind(null, mediaGallery, gallerythumbnail)
      );

      const image = document.createElement("img");
      image.classList.add("gallerythumbnail--button-image");
      image.src = itemImage.src.replace(/width=[0-9]+/, "width=100");

      button.append(image);
      gallerythumbnail.append(button);
    }

    if (gallerythumbnail.children.length > 0) {
      gallerythumbnail.children[0].setAttribute("data-selected", "");
    }

    const buttons = gallerythumbnail.querySelectorAll('.gallerythumbnail--button');
    let lastIndex = null;

    buttons.forEach((btn, idx) => {
      btn.addEventListener('click', () => {
        if (window.innerWidth <= 768) {
          lastIndex = idx;
          return;
        }

        if (lastIndex !== null) {
          const dir = idx - lastIndex;
          let targetIdx = null;

          if (dir === 1) {
            targetIdx = Math.min(idx + 1, buttons.length - 1);
          } else if (dir === -1) {
            targetIdx = Math.max(idx - 1, 0);
          }

          if (targetIdx !== null && targetIdx !== idx) {
            buttons[targetIdx].scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: dir === 1 ? 'end' : 'start'
            });
          }
        }
        lastIndex = idx;
      }, { passive: true });
    });

    // Re-initialize arrow navigation after variant change
    setTimeout(() => {
      initializeArrowNavigation();
    }, 100);
  }

  function initializeArrowNavigation() {
    const mediaGalleries = document.querySelectorAll('media-gallery');
  
    mediaGalleries.forEach(mediaGallery => {
      const horizontalSlider = mediaGallery.querySelector('.horizontal-slider');
      const gallerythumbnail = mediaGallery.parentElement.querySelector('[data-gallerythumbnail]');
      const prevBtn = mediaGallery.parentElement.querySelector('.slider-button--prev');
      const nextBtn = mediaGallery.parentElement.querySelector('.slider-button--next');
  
      if (!horizontalSlider || !gallerythumbnail || !prevBtn || !nextBtn) {
        console.warn('Test Gallery or buttons not found:', mediaGallery);
        return;
      }
  
      const activeSlides = getActiveMediaItems(mediaGallery);
      const thumbnailButtons = gallerythumbnail.querySelectorAll('.gallerythumbnail--button');
      if (activeSlides.length === 0 || thumbnailButtons.length === 0) {
        console.warn('No slides or thumbnails found');
        return;
      }
  
      let currentIndex = 0;
  
      console.log('✅ initializeArrowNavigation: total slides =', activeSlides.length);
  
      function updateArrowStates() {
        console.log(`Updating arrows: index=${currentIndex}`);
        if (currentIndex <= 0) {
          prevBtn.classList.add('is-disabled');
          prevBtn.setAttribute('disabled', 'disabled');
        } else {
          prevBtn.classList.remove('is-disabled');
          prevBtn.removeAttribute('disabled');
        }
  
        if (currentIndex >= activeSlides.length - 1) {
          nextBtn.classList.add('is-disabled');
          nextBtn.setAttribute('disabled', 'disabled');
        } else {
          nextBtn.classList.remove('is-disabled');
          nextBtn.removeAttribute('disabled');
        }
      }
  
      function navigateToSlide(index) {
        if (index < 0 || index >= activeSlides.length) return;
        currentIndex = index;
  
        thumbnailButtons.forEach(btn => btn.removeAttribute('data-selected'));
        if (thumbnailButtons[currentIndex]) {
          thumbnailButtons[currentIndex].setAttribute('data-selected', '');
        }
  
        const targetSlide = activeSlides[currentIndex];
        if (!targetSlide) return;
  
        const slideWidth = targetSlide.clientWidth;
        const scrollPosition = targetSlide.offsetLeft - (horizontalSlider.clientWidth / 2) + (slideWidth / 2);
  
        horizontalSlider.scrollTo({ left: scrollPosition, behavior: 'smooth' });
        updateArrowStates();
  
        console.log(`Navigated to slide ${currentIndex}`);
      }
  
      thumbnailButtons.forEach((btn, i) => {
        btn.addEventListener('click', (e) => {
          console.log(`[Thumbnail] Clicked index ${i}`);
          scrollItemIntoView(mediaGallery, gallerythumbnail, e, navigateToSlide);
        });
      });
  
      nextBtn.addEventListener('click', () => {
        console.log('Next clicked. Current index:', currentIndex);
        if (currentIndex < activeSlides.length - 1) {
          navigateToSlide(currentIndex + 1);
        }
      });
  
      prevBtn.addEventListener('click', () => {
        console.log('Prev clicked. Current index:', currentIndex);
        if (currentIndex > 0) {
          navigateToSlide(currentIndex - 1);
        }
      });
  
      updateArrowStates(); // initial
    });
  }
  
  ["variant:change","variant:changed","variant-change"].forEach(e => {
    document.addEventListener(e, () => console.log("Detected event:", e));
  });
  
  // Reinitialize arrows + thumbnails after variant changes
  document.addEventListener('variant-change', () => {
    console.log('[Gallery] Variant changed — reinitializing slider arrows');
    initializeArrowNavigation();
  });

  // Also handle Shopify section reloads (like quick view or dynamic rendering)
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.media-gallery')) {
      console.log('[Gallery] Section reloaded — reinitializing slider arrows');
      initializeArrowNavigation();
    }
  });

  window.updateGallerythumbnail = updateGallerythumbnail;

  function scrollItemIntoView(mediaGallery, gallerythumbnail, event, navigateCallback) {
    for (const button of gallerythumbnail.children) {
      button.removeAttribute("data-selected");
    }

    const clickedButton = event.currentTarget;
    clickedButton.setAttribute("data-selected", "");
    const buttonIndex = parseInt(clickedButton.getAttribute("data-index"));
    const totalButtons = gallerythumbnail.children.length;
    
    if (buttonIndex === 1) {
      scrollThumbLeftAlign(gallerythumbnail, gallerythumbnail.children[0]);
    }
    if (buttonIndex >= totalButtons - 2) {
      scrollThumbLeftAlign(gallerythumbnail, gallerythumbnail.children[totalButtons - 1]);
    }
    // Highlight selected thumbnail
    gallerythumbnail.querySelectorAll('.gallerythumbnail--button').forEach(btn => btn.removeAttribute('data-selected'));
    clickedButton.setAttribute('data-selected', '');

    // Call the same navigation function arrows use
    if (typeof navigateCallback === 'function') {
      navigateCallback(buttonIndex);
    }
    
    // FIXED: Use consistent selector function
    const activeMediaItems = getActiveMediaItems(mediaGallery);
    const targetItem = activeMediaItems[buttonIndex];

    if (!targetItem) {
      console.error("Target item not found for index:", buttonIndex);
      console.log("Available items:", activeMediaItems.length, "Requested index:", buttonIndex);
      return;
    }

    const horizontalSlider = mediaGallery.querySelector('.horizontal-slider');
    if (horizontalSlider) {
      const sliderWidth = horizontalSlider.clientWidth;
      const itemOffset = targetItem.offsetLeft;
      const itemWidth = targetItem.clientWidth;
      const scrollTo = itemOffset - (sliderWidth / 2) + (itemWidth / 2);

      horizontalSlider.scrollTo({
        left: scrollTo,
        behavior: 'smooth'
      });
    }

    mediaGallery.scrollTo({
      top: targetItem.offsetTop,
      behavior: "smooth",
    });

    const isCustomTemplate = document.querySelector('.eva-custom-product-container');
    if (isCustomTemplate) {
      window.scrollTo({
        top: mediaGallery.offsetTop,
        behavior: "smooth",
      });
    } else {
      if (gallerythumbnail.children.length > 1) {
        if (clickedButton === gallerythumbnail.children[0]) {
          window.scrollTo({
            top: mediaGallery.offsetTop,
            behavior: "smooth",
          });
        } else if (
          clickedButton === gallerythumbnail.children[gallerythumbnail.children.length - 1]
        ) {
          window.scrollTo({
            top: mediaGallery.offsetTop + mediaGallery.offsetHeight - window.innerHeight,
            behavior: "smooth",
          });
        }
      }
    }
  }
})();